<template>
  <div
    class="product-thumb"
    :style="boxStyle"
    :aria-label="alt"
    role="img"
  >
    <img
      class="product-thumb__img"
      :src="imgSrc"
      :alt="alt"
    />
  </div>
</template>

<script>
import productPng from "@/assets/image/product.png";

export default {
  name: "ProductThumb",
  props: {
    /** 外框边长（px，设计稿数值，会由 postcss 转 vw） */
    size: {
      type: Number,
      default: 100,
    },
    alt: {
      type: String,
      default: "商品",
    },
  },
  data() {
    return {
      imgSrc: productPng,
    };
  },
  computed: {
    boxStyle() {
      const s = `${this.size}px`;
      return {
        width: s,
        height: s,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/* 竖版产品图：固定方形容器 + contain，保留浅灰底与立体质感 */
.product-thumb {
  border-radius: 12px;
 
  flex-shrink: 0;
  box-sizing: border-box;
}

.product-thumb__img {
  display: block;
  width: 100%;
  object-fit: contain;
  object-position: center;
}
</style>
